export const decricaoSituacao: { label: string; descricao: string }[] = [
  {
    label: 'Aguardando Análise – CASAN',
    descricao:
      'sua solicitação já foi recebida por nossa equipe comercial. Protocolo de serviço ainda não foi aberto;',
  },
  {
    label: 'Aguardando Documentação – Cliente',
    descricao:
      'solicitação foi devolvida ao usuário para que assine os documentos necessários e encaminhe à CASAN;',
  },
  {
    label: 'Aguardando Execução – CASAN',
    descricao:
      'equipe comercial da CASAN já fez a abertura do protocolo. Protocolo de serviço aguardando execução;',
  },
  {
    label: 'Documentação Complementar – CASAN',
    descricao:
      'foi encaminhada documentação complementar e aguarda finalização do atendimento;',
  },
  {
    label: 'Em Análise – CASAN',
    descricao:
      'a solicitação está sendo analisada por um de nossos atendentes. Protocolo de serviço ainda não foi aberto;',
  },
  {
    label: 'Rejeitado',
    descricao:
      ' a solicitação foi rejeitada por estar em desacordo com as normas da CASAN. É permitido que o usuário encaminhe os documentos faltantes POR UMA VEZ antes da solicitação ser rejeitada definitivamente;',
  },
  {
    label: 'Serviço Cancelado – CASAN',
    descricao:
      ' equipe comercial da CASAN já fez a abertura do protocolo, porém o serviço foi cancelado;',
  },
  {
    label: 'Serviço Executado – CASAN',
    descricao:
      ' equipe comercial da CASAN já fez a abertura do protocolo e o serviço já foi executado.',
  },
];
